const saleDeletedPage = require('./saleDeleted-page')
const saleDeletedDt = require('./saleDeleted-dt')
const saleDeletedFullcont = require('./saleDeleted-fullcont')

export function start(detail) {
  const component = components[detail.elem]
  if (component) component.start(detail)
}

const components = {
  page: { start: detail => saleDeletedPage.start(detail) },
  dt: { start: detail => saleDeletedDt.start(detail) },
  fullcont: { start: detail => saleDeletedFullcont.start(detail) }
}

